import { render, staticRenderFns } from "./user.vue?vue&type=template&id=5467e654"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports